import { render, staticRenderFns } from "./AltaPsp.vue?vue&type=template&id=75873310&scoped=true"
import script from "./AltaPsp.vue?vue&type=script&lang=js"
export * from "./AltaPsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75873310",
  null
  
)

export default component.exports